import {
	AuthenticationGroupDetailsAccount,
	AuthenticationGroupDetailsSession,
} from "@cofano/coastguard2-frontend-client";
import CoastguardSessionSelectApplication from "./CoastguardSessionSelectApplication";
import CoastguardImpersonationIcon from "./CoastguardImpersonationIcon";
import CoastguardSessionImpersonatorTooltip from "components/layout/coastguard/CoastguardSessionImpersonatorTooltip";
import CoastguardUserDetails from "components/layout/coastguard/CoastguardUserDetails";
import { Box } from "@mui/material";

export type SessionSelectAccountProps = {
	account: AuthenticationGroupDetailsAccount;
	impersonator: AuthenticationGroupDetailsAccount | null;
	sessions: AuthenticationGroupDetailsSession[];
	currentSessionUuid: string | null;
	switchSession: (sessionUuid: string) => void;
	logoutSession: (sessionUuid: string) => void;
	hideAccountDetails: boolean;
};

const CoastguardSessionSelectAccount = (props: SessionSelectAccountProps) => {
	return !props.hideAccountDetails ? (
		<Box
			paddingX={1}
			paddingY={0.5}
			sx={{
				minWidth: 0,
				border: (theme) => `1px solid ${theme.palette.divider}`,
				backgroundColor: props.impersonator != null
					? (theme) => theme.palette.mode === "dark" ? "#212121" : theme.palette.action.selected
					: undefined,
			}}
		>
			<Box
				display="flex"
				alignItems="center"
				justifyContent="space-between"
				gap={1}
			>
				<CoastguardUserDetails userDetails={props.account} useSecondaryColors />
				{props.impersonator != null && (
					<CoastguardSessionImpersonatorTooltip impersonator={props.impersonator}>
						<span>
							<CoastguardImpersonationIcon
								sx={{
									fontSize: 20,
									mr: 2,
									color: (theme) => theme.palette.mode === "dark" ? "#C371FF" : "#4B0082",
								}}
							/>
						</span>
					</CoastguardSessionImpersonatorTooltip>
				)}
			</Box>
			<Box marginTop={1}>
				{props.sessions.map((session) => (
					<CoastguardSessionSelectApplication
						key={session.applicationSessionUuid}
						session={session}
						currentSessionUuid={props.currentSessionUuid}
						switchSession={props.switchSession}
						logoutSession={props.logoutSession}
					/>
				))}
			</Box>
		</Box>
	) : (
		<>
			{props.sessions.map((session) => (
				<CoastguardSessionSelectApplication
					key={session.applicationSessionUuid}
					session={session}
					currentSessionUuid={props.currentSessionUuid}
					switchSession={props.switchSession}
					logoutSession={props.logoutSession}
				/>
			))}
		</>
	);
};

export default CoastguardSessionSelectAccount;
